import {SODeleteAlertSubscription} from '../../core/alert-subscription/so-delete-alert-subscription';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAlertSubscription extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAlertSubscription;
}